import { render, staticRenderFns } from "./govInfo.vue?vue&type=template&id=16553478&scoped=true&"
import script from "./govInfo.vue?vue&type=script&lang=js&"
export * from "./govInfo.vue?vue&type=script&lang=js&"
import style0 from "./govInfo.vue?vue&type=style&index=0&id=16553478&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16553478",
  null
  
)

export default component.exports